
import React from 'react';
import { Calendar, Activity, BookOpen, Award } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { StatCard } from './StatCard';
import { DashboardData } from '@/hooks/use-dashboard-data';

interface StatCardsProps {
  isLoading: boolean;
  data: DashboardData | undefined;
}

export const StatCards = ({ isLoading, data }: StatCardsProps) => {
  const currentStreak = data?.streak?.current ?? 0;
  const weeklyProgress = data?.weeklyProgress ?? 0;
  const completedModules = data?.moduleProgress?.completed ?? 0;
  const totalModules = data?.moduleProgress?.total ?? 0;

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <div 
            key={i}
            className="glass-card rounded-xl p-5 animate-pulse"
            style={{ height: "150px" }}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatCard 
        icon={<Calendar className="h-5 w-5" />}
        title="Current Streak"
        value={`${currentStreak} days`}
        description="Keep it going!"
        color="blue"
      />
      
      <StatCard 
        icon={<Activity className="h-5 w-5" />}
        title="Weekly Progress"
        value={`${weeklyProgress}%`}
        description={<Progress value={weeklyProgress} className="h-2 mt-2" />}
        color="green"
      />
      
      <StatCard 
        icon={<BookOpen className="h-5 w-5" />}
        title="Learning Modules"
        value={`${completedModules}/${totalModules}`}
        description="Modules completed"
        color="purple"
      />
      
      <StatCard 
        icon={<Award className="h-5 w-5" />}
        title="Executive Level"
        value="AI Explorer"
        description={`${5 - (currentStreak % 5)} more days to level up`}
        color="amber"
      />
    </div>
  );
};
